import { render, staticRenderFns } from "./TrackProductImpression.vue?vue&type=template&id=79187d6e"
import script from "./TrackProductImpression.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrackProductImpression.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrackImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackImpression.vue').default,SplitTest: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/SplitTest.vue').default})
